export default "__VITE_ASSET__f6cc1626__"